import React, { useState, useEffect } from 'react'
import { Modal, message, Upload, Button } from 'antd'
import BasicForm from '../formV4'
import { saveFacilityLogo, createFacility, editFacility } from '../../api'
import _ from 'lodash'
import styled from 'styled-components'
import moment from 'moment'
import { facilityFormModels } from '../../models/facility.upsert.form'

const StyledModal = styled(Modal)`
  .title {
    font-size: 36px;
    font-weight: 600;
  }
  .upload-avatar {
    margin-bottom: 24px;
  }

  .facility-logo-placeholder {
    background-color: #eceef4;
    font-size: 14px;
    letter-spacing: 0.3px;
    font-weight: 600;
    height: 89px;
    width: 452px;
    color: #263382;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 11px;
    cursor: pointer;

    & > img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }

  .has-logo {
    background-color: transparent;
    border: 1px solid rgba(175, 175, 175, 0.45);
  }
`

const FacilityFormModal = (props) => {
  const { initValue, onCancel, submitSync, onDelete } = props

  const [loading, setLoading] = useState(false)
  const [file, setFile] = useState(null)
  const [valueForm, setValueForm] = useState(null)
  const [imageUrl, setImageUrl] = useState('')
  const [formRef, setFormRef] = useState(null)

  useEffect(() => {
    if (!_.isEmpty(initValue)) {
      const v = _.cloneDeep(initValue)
      v.open_time = moment(v.open_time, 'HH:mm:ss')
      v.close_time = moment(v.close_time, 'HH:mm:ss')
      setValueForm(v)
    } else {
      setValueForm({})
    }
  }, [initValue])

  const submit = async () => {
    setLoading(true)

    try {
      const params = await formRef.handleSubmit()
      params.open_time = moment(params.open_time, 'h:mm A').format('HH:mm:ss')
      params.close_time = moment(params.close_time, 'h:mm A').format('HH:mm:ss')
      let facility, successMsg, syncType
      if (_.isEmpty(initValue)) {
        facility = await createFacility(params)
        syncType = 'create'
        successMsg = 'Facility created!'
      } else {
        facility = await editFacility(params, initValue.id)
        syncType = 'update'
        successMsg = 'Facility updated!'
      }
      if (file) {
        facility = await saveFacilityLogo(file, facility.id)
      }
      setLoading(false)
      submitSync(facility, syncType)
      message.success(successMsg)
    } catch (err) {
      console.error(err)
      setLoading(false)
    }
  }

  const cancel = () => {
    formRef && formRef.resetFields()
    onCancel()
  }

  const getBase64 = (img, callback) => {
    const reader = new FileReader()
    reader.addEventListener('load', () => callback(reader.result))
    reader.readAsDataURL(img)
  }

  const customRequest = (request) => {
    const { file } = request
    getBase64(file, (imageUrl) => {
      setImageUrl(imageUrl)
      setFile(file)
    })
  }

  const avatar =
    imageUrl || (initValue && initValue.logo && initValue.logo.oss_url)
  const formModels = facilityFormModels(disabled, validateTime)

  return (
    <StyledModal
      open={true}
      onCancel={cancel}
      width={500}
      footer={
        <>
          {!_.isEmpty(initValue) && (
            <Button
              danger
              ghost
              onClick={() => onDelete(initValue)}
              style={{
                float: 'left'
              }}
            >
              DELETE FACILITY
            </Button>
          )}

          <Button onClick={onCancel} ghost type="primary">
            CANCEL
          </Button>
          <Button onClick={submit} type="primary" loading={loading}>
            {_.isEmpty(initValue) ? 'CREATE' : 'UPDATE'}
          </Button>
        </>
      }
    >
      <h1 className="title">
        {' '}
        {_.isEmpty(initValue) ? 'Add Facility' : 'Edit Facility'}
      </h1>
      <div className="upload-avatar">
        <Upload
          name="avatar"
          customRequest={customRequest}
          showUploadList={false}
        >
          <div
            className={`facility-logo-placeholder ${avatar ? 'has-logo' : ''}`}
          >
            {avatar ? (
              <img
                src={avatar}
                alt="aaa"
                style={{
                  objectFit: 'scale-down'
                }}
              />
            ) : (
              <> + Upload Logo</>
            )}
          </div>
        </Upload>
      </div>
      {valueForm && (
        <div style={{ marginBottom: '30px' }}>
          <BasicForm
            wrappedComponentRef={(inst) => setFormRef(inst)}
            initialValues={valueForm}
            formData={formModels}
            onChange={(changedValues, allValues) =>
              setValueForm({ ...allValues })
            }
          />
        </div>
      )}
    </StyledModal>
  )

  function disabled(time, type, hour) {
    if (time === 'hours') {
      return getDisabledHour(type)
    } else {
      return getDisabledMinute(type, hour)
    }
  }

  function getDisabledHour(type) {
    let compareTime, hour, minute
    let result = Array.from(Array(24), (v, k) => k)
    if (type === 'open') {
      const openTime = moment(valueForm.open_time)
      compareTime = moment(valueForm.close_time, 'h:mm A')
      hour = compareTime.hour()
      minute = compareTime.minute()
      result = result.filter((item) => {
        if (minute > 0 && openTime.minute() < minute) {
          return item >= hour
        } else {
          return item > hour
        }
      })
    } else {
      const closeTime = moment(valueForm.close_time)
      compareTime = moment(valueForm.open_time, 'h:mm A')
      hour = compareTime.hour()
      minute = compareTime.minute()
      result = result.filter((item) => {
        if (minute > 0 && closeTime.minute() > minute) {
          return item <= hour
        } else {
          return item < hour
        }
      })
    }
    return result
  }

  function getDisabledMinute(type, selectHour) {
    let compareTime, hour, minute
    let result = Array.from(Array(60), (v, k) => k)
    if (type === 'open') {
      compareTime = moment(valueForm.close_time, 'h:mm A')
      hour = compareTime.hour()
      minute = compareTime.minute()
      result = result.filter((item) => {
        if (selectHour === hour) {
          return item > minute
        }
        return false
      })
    } else {
      compareTime = moment(valueForm.open_time, 'h:mm A')
      hour = compareTime.hour()
      minute = compareTime.minute()
      result = result.filter((item) => {
        if (selectHour === hour) {
          return item < minute
        }
        return false
      })
    }

    return result
  }

  function validateTime(type, value) {
    let compareTime, hour, minute
    if (type === 'open' && valueForm.close_time) {
      compareTime = valueForm.close_time
      hour = compareTime.hour()
      minute = compareTime.minute()
      if (
        value.hour() > hour ||
        (value.hour() === hour && value.minute() >= minute)
      ) {
        return Promise.reject(new Error('Open time should be ahead close time'))
      }
    } else if (type === 'close' && valueForm.open_time) {
      compareTime = valueForm.open_time
      hour = compareTime.hour()
      minute = compareTime.minute()
      if (
        value.hour() < hour ||
        (value.hour() === hour && value.minute() <= minute)
      ) {
        return Promise.reject(
          new Error('Close time should be behind open time')
        )
      }
    }
    return Promise.resolve()
  }
}

export default FacilityFormModal
